export default class SingleAnimation {
	constructor(id, fromX, fromY, toX, toY) {
		this.objectID = id;
		this.fromX = fromX;
		this.fromY = fromY;
		this.toX = toX;
		this.toY = toY;
	}
}
